module.exports = __webpack_public_path__ + "img/1440.5107cb43.jpg";